const storage = window.localStorage || {}
const NAME_TIMESPAN = '_timespan'
const NAME_CREATE_TIME = '_createtime'
export default {
  serialize(value) {
    return JSON.stringify(value)
  },
  deserialize(value) {
    if (typeof value !== 'string') {
      return undefined
    }
    try {
      return JSON.parse(value)
    } catch (e) {
      return value || undefined
    }
  },
  isSupportLocalStorage() {
    try {
      return 'localStorage' in window && window.localStorage
    } catch (err) {
      return false
    }
  },
  /**
   *
   * @param {string} key
   * @param {Object} val
   * @param {number?} timespan 单位 s
   */
  setItem(key, val, timespan = null) {
    if (val !== undefined) {
      storage.setItem(key, this.serialize(val))
      if (timespan) {
        storage.setItem(key + NAME_TIMESPAN, timespan)
        storage.setItem(key + NAME_CREATE_TIME, +new Date())
      }
    } else {
      return storage.removeItem(key)
    }
    return val
  },
  getItem(key) {
    const timespan = storage.getItem(key + NAME_TIMESPAN)
    if (timespan && isFinite(timespan)) {
      const createTime = +storage.getItem(key + NAME_CREATE_TIME)
      const now = +new Date()
      if (now - createTime > timespan * 1e3) {
        this.removeItem(key)
        this.removeItem(key + NAME_TIMESPAN)
        this.removeItem(key + NAME_CREATE_TIME)
        return null
      }
    }
    const val = this.deserialize(storage.getItem(key))
    return val
  },
  removeItem(key) {
    storage.removeItem(key)
  },
  clear() {
    storage.clear()
  },
  getAll() {
    const all = {}
    this.forEach((key, val) => {
      all[key] = val
    })
    return all
  },
  forEach(callback) {
    if (!callback) return
    for (let i = 0; i < storage.length; i += 1) {
      const key = storage.key(i)
      callback(key, this.getItem(key))
    }
  },
}
